// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"#492172","tertiary":"#BFD730","outer":"_24WH","filled":"MzOd","inner":"_spg","button":"_2BKk","logo":"_1Atf","confirmationWarning":"_w17"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.scss
// module id = ykdQ
// module chunks = 0